import { render } from "./App.vue?vue&type=template&id=25ae21a7"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=25ae21a7&lang=css"

import exportComponent from "/Volumes/LACIE/vueSites/2022/dernek/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__